type StampFields = {
    roller?: number
    range?: number
    length?: number
}

export default function getNumberOfLabelsInFlood(stamp: StampFields) {
    const { roller, range, length } = stamp

    if (!roller || !range || !length) return

    return Math.round(roller / (range + length))
}
